import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Music">
                <h1>Music App Development Services</h1>
              </div>
              <p className="main_para">
                Become the next music sensation with our expert music app
                development company. Our skilled music app developers create
                cutting-edge solutions to launch your unique music streaming
                app.
              </p>
              <p>
                Stand out in the industry alongside giants like Spotify and
                Apple Music, as our team refines every detail to perfectly match
                your vision.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
